/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const DELETE_CHECK_LOG_LOADING = 'DELETE_CHECK_LOG_LOADING';
export const OMITTED_CLAIM_TABLE_REBATE_PROGRAM_DATA =
  'OMITTED_CLAIM_TABLE_REBATE_PROGRAM_DATA';
export const DELETE_CHECK_LOG_FILTER = 'DELETE_CHECK_LOG_FILTER';
export const DELETE_CHECK_LOG_USERDEFAULT = 'DELETE_CHECK_LOG_USERDEFAULT';
export const SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES';
export const SET_SEARCH_ERROR_MSG = 'SET_SEARCH_ERROR_MSG';
export const DELETE_CHECK_LOG_RESET_STORE = 'DELETE_CHECK_LOG_RESET_STORE';
export const SET_PLAN_TYPE = 'SET_PLAN_TYPE';
export const SET_SELECT_TYPE = 'SET_SELECT_TYPE';
export const SET_ACTIONS_TYPE = 'SET_ACTIONS_TYPE';
export const CLAIM_SELECT_BY_FILTER = 'CLAIM_SELECT_BY_FILTER';
export const CLAIM_SELECTED_NDC_TAB = 'CLAIM_SELECTED_NDC_TAB';
export const RESET_REQUEST_CLAIM_DATA = 'RESET_REQUEST_CLAIM_DATA';
export const SET_DRUG_FAMILY_DETAILS = 'SET_DRUG_FAMILY_DETAILS';
export const SET_SELECTED_DRUG_FAMILY_ROW = 'SET_SELECTED_DRUG_FAMILY_ROW';
export const DRUG_FAMILY_PROCESS_RESPONSE = 'DRUG_FAMILY_PROCESS_RESPONSE';
